import { Password } from '@or-sdk/password';

import { useAuthStore } from '@/stores/auth/auth';
import { sdkApiUrl } from '@/utils/authUiRuntime';

export default new Password({
  sdkApiUrl,
  token: () => useAuthStore().reactiveToken as string,
});
